module.exports = __webpack_public_path__ + "img/time1.2c978b85.png";